import PropTypes from "prop-types"

export const ImageFields = {
  title: PropTypes.string,
  description: PropTypes.string,
  file: PropTypes.shape({
    url: PropTypes.string,
  }),
}

// ButtonV2Props for homeHeroCallsToActions
export const ButtonV2Props = {
  id: PropTypes.string.isRequired,
  accessibilityLabel: PropTypes.string,
  buttonSize: PropTypes.string,
  buttonStyle: PropTypes.string,
  path: PropTypes.string,
  text: PropTypes.string.isRequired,
}

// HomeHeroCardProps
export const HomeHeroCardProps = {
  id: PropTypes.string.isRequired,
  homeHeroCardTitle: PropTypes.string.isRequired,
  homeHeroCardTheme: PropTypes.string.isRequired,
  homeHeroCardImage: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
    title: PropTypes.string,
    description: PropTypes.string,
  }),
}

export const HeroV2Props = {
  id: PropTypes.string.isRequired,
  heroTitle: PropTypes.string.isRequired,
  homeText: PropTypes.string.isRequired,
  homeHeroCallsToActions: PropTypes.arrayOf(PropTypes.shape(ButtonV2Props)),
  homeHeroCards: PropTypes.arrayOf(PropTypes.shape(HomeHeroCardProps)),
  homeHeroImage: PropTypes.shape({
    ...ImageFields,
  }),
}
